// 开发环境域名

const hostDevelopment = 'https://uat.saas.kaopush.net'

export default {
    // 版本
    version: '2.2.1',
    baseURL: process.env.NODE_ENV === 'production' ? 'https://uat.saas.kaopush.net' : hostDevelopment,
    tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}
